<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="logbookGlider.plane_type"
          field-name="plane_type"
          rules="required"
          type="text"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="logbookGlider.plane_regnum"
          field-name="plane_regnum"
          rules="required|alpha_dash|min:4|max:10"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <date-field
          v-model="logbookGlider.date"
          field-name="date"
          rules="required|date"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="logbookGlider.takeoff_airport"
          field-name="takeoff_airport"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="logbookGlider.takeoff_time"
          field-name="takeoff_time"
          rules="time"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="logbookGlider.landing_airport"
          field-name="landing_airport"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="logbookGlider.landing_time"
          field-name="landing_time"
          rules="time"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="logbookGlider.flight_time"
          field-name="flight_time"
          rules="required|time"
          :disabled="(logbookGlider.takeoff_time && logbookGlider.takeoff_time !== '') || (logbookGlider.landing_time && logbookGlider.landing_time !== '')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <glider-takeoff-type
          v-model="logbookGlider.takeoff_type"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <validated-text-field
          v-model="logbookGlider.takeoff"
          field-name="takeoff"
          rules="required|numeric|min_value:1|max_value:50"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="7"
      >
        <validated-text-field
          v-model="logbookGlider.task"
          field-name="task"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGlider.is_tmg"
          :label="$t('fields.is_tmg')"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGlider.pft_pic"
          :label="$t('fields.pft_pic')"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGlider.pft_dual"
          :label="$t('fields.pft_dual')"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGlider.pft_instructor"
          :label="$t('fields.pft_instructor')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="logbookGlider.route"
          field-name="route"
          rules=""
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="logbookGlider.other_person"
          field-name="other_person"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <validated-text-field
          v-model="logbookGlider.altitude"
          field-name="altitude"
          rules="numeric|min_value:1|max_value:10000"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <validated-text-field
          v-model="logbookGlider.distance"
          field-name="distance"
          rules="numeric|min_value:1|max_value:10000"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <validated-text-field
          v-model="logbookGlider.comment"
          field-name="comment"
          rules="max:500"
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditLogbookGlider',
    props: {
      logbookGlider: Object,
    },
  }
</script>
